import { render, staticRenderFns } from "./OnboardingInstallationLimitModal.vue?vue&type=template&id=4b8b77e4&scoped=true"
import script from "./OnboardingInstallationLimitModal.vue?vue&type=script&lang=js"
export * from "./OnboardingInstallationLimitModal.vue?vue&type=script&lang=js"
import style0 from "./OnboardingInstallationLimitModal.vue?vue&type=style&index=0&id=4b8b77e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b77e4",
  null
  
)

export default component.exports